// extracted by mini-css-extract-plugin
export default {"header":"SaveContragents_header__xqUOG","wrapperAddButton":"SaveContragents_wrapperAddButton__fC-NO","loader":"SaveContragents_loader__zJE-W"};